import ReactGA from 'react-ga';

export const getHotelAnalyticsName = (hotel) => (hotel.analytics_name || hotel.name);

const hasEnabledAnalytics = () => {
  const env = process.env.NODE_ENV;
  return env === 'production' || env === 'docker'; // Staging has enabled true
};

export const addEventToDataLayer = (data, errorIfNotEnabled) => {
  if (!hasEnabledAnalytics()) {
    if (errorIfNotEnabled) {
      Raven.captureException(errorIfNotEnabled);
    }
    return;
  }
  data.bookingEngine = 'v4'; // eslint-disable-line no-param-reassign
  window.dataLayer.push(data);
};

export const sendGA = (tag, data) => {
  if (!hasEnabledAnalytics()) {
    return;
  }
  ReactGA.ga('send', tag, data);
};

export const configureAnalytics = (uaCode, gtmCode) => {
  if (!hasEnabledAnalytics()) {
    return;
  }

  // Analytics
  if (uaCode) {
    ReactGA.initialize(uaCode); // Needs to be the first call to ReactGA. Internally, it calls ga.create('UA-..')
    ReactGA.ga('send', 'pageview');
  }

  // Inyectando GTM...
  if (gtmCode) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    const cont = document.getElementsByTagName('script')[0];
    if (cont) {
      const gtmcont = document.createElement('script');
      gtmcont.async = true;
      gtmcont.src = `//www.googletagmanager.com/gtm.js?id=${gtmCode}`;
      cont.parentNode.insertBefore(gtmcont, cont);
    }
  }
};

const toUtmValue = (paramKey, value) => {
  if (!value) {
    return '';
  }
  // If this is the "extra" parameter, then we generate the entire object as a JSON
  // If this is a named parameter (eg. utm_source), then we just want to sanitise it
  return paramKey === 'extra' ? JSON.stringify(value) : encodeURIComponent(value);
};

// Stuff related with retrieving and storing UTM parameters
export const buildExtraAnalyticsParams = (utmParams) => {
  const extraParams = Object.keys(utmParams).map((paramKey) => {
    const originalValue = utmParams[paramKey];
    return {
      name: paramKey,
      value: toUtmValue(paramKey, originalValue),
    };
  });
  return extraParams.filter((param) => !!param.value);
};
